<template>
    <c-footer :fixed="false">
        <slot/>
    </c-footer>
</template>
<script setup>
import {CFooter} from "@coreui/vue/dist/esm/components/footer/index.js";
</script>
